import angular from 'angular';
import uiRouter from 'angular-ui-router';
import creditorsComponent from './creditors.component';
import dataTable from 'angular-material-data-table';

let creditorsModule = angular
  .module('creditors', [uiRouter, dataTable])

  .config($stateProvider => {
    'ngInject';
    $stateProvider.state('creditors', {
      url: '/creditors',
      component: 'creditors',
      parent: 'main',
      data: {
        permissions: {
          only: ['ADMIN'],
          redirectTo: 'home'
        }
      },
      resolve: {}
    });
  })
  .component('creditors', creditorsComponent).name;

export default creditorsModule;
